import React from "react";
import AddEmpleadoForm from "./AddEmpleadoForm";

const AddEmpleado = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Empleado"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddEmpleadoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddEmpleado;
